import { useAppDispatch, useAppSelector } from 'common';
import { RecipeCustomerUserManage } from 'common/src/api/models/recipe-customer-user-manage.models';
import {
  getRecipeCustomerUserManages,
  selectAllRecipeCustomerUserManageData,
  selectAllRecipeCustomerUserManages,
} from 'common/src/store/recipes';
import { useEffect, useState } from 'react';
import { CfDataGridProps } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { CfDataGridContainer } from '../../../../cf-ui/DataGridContainer/CfDataGridContainer';
import { StyledViewBox } from '../../../_shared/components/shared-styled-components.styles';
import RecipeManageUsersDialog, {
  RecipeManageUsersDialogProps,
} from '../../../recipes/components/RecipeManageUsersDialog/RecipeManageUsersDialog';
import { recipeEditorsTableView } from '../../components/gridTablesView/RecipeEditorsTableView';
import { ManageAccessTableHeader } from '../../components/headers/ManageAccessTableHeader';

export default function RecipeEditors(): JSX.Element {
  const dispatch = useAppDispatch();

  const [searchParam, setSearchParam] = useState('');
  const [manageUsersDialog, setManageUsersDialog] = useState<RecipeManageUsersDialogProps | undefined>(undefined);

  const customerId = useAppSelector((s) => s.customer.selectedCustomer?.CustomerId) || '';
  const manageUsers = useAppSelector((s) => selectAllRecipeCustomerUserManages(s.recipes.recipeCustomerUserManages));
  const filteredManageUsers = useAppSelector((s) => selectAllRecipeCustomerUserManageData(s, searchParam));
  const isLoading = useAppSelector((s) => s.recipes.isRecipeCustomerUserManagesLoading);

  useEffect(() => {
    dispatch(getRecipeCustomerUserManages(customerId));
  }, []);

  const handleManageLocation = () => {
    setManageUsersDialog({
      customerId,
      onClose: () => setManageUsersDialog(undefined),
    });
  };

  const dataGridProps: CfDataGridProps<RecipeCustomerUserManage> = {
    id: 'recipeWorkSheetGrid',
    tableView: recipeEditorsTableView(),
    selectId: (item: RecipeCustomerUserManage) => item.UserId,
    displayMode: 'table',
    autoFocus: 'filter',
    noItemsMessage: 'No users found',
    data: {
      pages: [
        {
          pageIndex: 0,
          isLoading: isLoading,
          items: filteredManageUsers,
          pageSize: isLoading ? 4 : filteredManageUsers.length,
        },
      ],
      totalPageCount: 1,
      totalItemCount: manageUsers.length,
      pagingMode: 'none',
    },
  };

  return (
    <StyledViewBox>
      <CfDataGridContainer
        dataGridProps={dataGridProps}
        sx={{
          '& .css-nsyoup-MuiCardContent-root': {
            padding: 0,
            margin: 0,
          },
        }}
        controlsContainerSx={{ padding: 0, margin: 0 }}
        customControlsContainer={
          <ManageAccessTableHeader
            title='Recipe editors'
            description='Manage users from shared locations who can edit all recipes.'
            searchPlaceholder='Search editors'
            setSearchParam={setSearchParam}
            handleDialog={handleManageLocation}
            isRecipeEditors={true}
          />
        }
      />
      {manageUsersDialog && <RecipeManageUsersDialog {...manageUsersDialog} />}
    </StyledViewBox>
  );
}
